import React from "react";
import { actionViewTabs } from "../../../data.js";
import ActionCard from "./ActionCard/index.js";

const Actions = ({component, t ,collection,setCollectionId}) => <ActionCard component={component} collection={collection} actionViewTabs={actionViewTabs} t={t} />;

export default Actions;
